"use client";

import * as React from "react";

import { RouterLike } from "./types";

/**
 * `null` means no provider supplied the value, so consumers fall back to react-router.
 * Kept separate from `RoutingContext` so a URL change only re-renders components that read it.
 */
export const RoutingRouterContext: React.Context<RouterLike | null> =
  React.createContext<RouterLike | null>(null);

export const RoutingPathnameContext: React.Context<string | null> =
  React.createContext<string | null>(null);

export const RoutingSearchContext: React.Context<string | null> =
  React.createContext<string | null>(null);
